__turbopack_context__.v({
  "borderless": "style-module-scss-module__GkVpGG__borderless",
  "component": "style-module-scss-module__GkVpGG__component",
  "component-full-screen": "style-module-scss-module__GkVpGG__component-full-screen",
  "title": "style-module-scss-module__GkVpGG__title",
});
